import { z } from 'zod';
export const offerRequestCreditTransactionTypeSchema = z.enum(['OfferRequestDelivery', 'OfferRequestReimbursement']);
// Transaction types not tied to an offer request.
export const otherCreditTransactionTypeSchema = z.enum([
    'PartnerProductPayment',
    'ProductCancellation',
    'Correction',
    'ReservedForSubscriptionMigration',
    'ReleasedFromSubscriptionMigration',
    'MigratedToSubscription',
]);
export const creditTransactionTypeSchema = z.enum([
    ...offerRequestCreditTransactionTypeSchema.options,
    ...otherCreditTransactionTypeSchema.options,
]);
export const partnerCreditsWalletSchema = z.object({
    availableCredits: z.number().int(),
});
const baseCreditTransactionFields = {
    uuid: z.uuid(),
    date: z.iso.datetime(),
    credits: z.number().int(),
    balance: z.number().int(),
};
export const creditTransactionSchema = z.discriminatedUnion('type', [
    z.object({
        ...baseCreditTransactionFields,
        type: offerRequestCreditTransactionTypeSchema,
        offerRequestReferenceId: z.string(),
        offerRequestLeadUuid: z.uuid().nullable(),
    }),
    z.object({
        ...baseCreditTransactionFields,
        type: otherCreditTransactionTypeSchema,
    }),
]);
export const partnerCreditTransactionsPageSchema = z.object({
    items: z.array(creditTransactionSchema),
    total: z.number().int(),
});
